import React from 'react';
import { Link } from 'react-router-dom';
import { courses } from '../data';
import '../CSS/Courses.css';

const Courses = () => {
  return (
    <main className="courses-page">
      <div className="container">
        <div className="courses-hero">
          <span className="section-label">Learn</span>
          <h1 className="courses-hero__title">Courses</h1>
          <p className="courses-hero__desc">
            Structured learning paths for modern web development. From fundamentals to production-ready systems.
          </p>
        </div>

        <div className="courses-page__grid">
          {courses.map((course) => (
            <div key={course.id} className="course-full-card">
              <div className="course-full-card__cover" style={{ background: course.gradient }}>
                <span className="course-full-card__icon">{course.icon}</span>
                {course.badge && (
                  <span className="course-full-card__badge" style={{ background: course.badgeColor }}>
                    {course.badge}
                  </span>
                )}
              </div>
              <div className="course-full-card__body">
                <div className="course-card__tags">
                  {course.tags.map(t => (
                    <span key={t} className="blog-card__tag">{t}</span>
                  ))}
                </div>
                <h2 className="course-full-card__title">{course.title}</h2>
                <p className="course-full-card__desc">{course.description}</p>
                <div className="course-full-card__meta">
                  <div className="course-full-card__stat">
                    <span className="course-full-card__stat-icon">📚</span>
                    <span>{course.lessons} lessons</span>
                  </div>
                  <div className="course-full-card__stat">
                    <span className="course-full-card__stat-icon">⏱</span>
                    <span>{course.duration}</span>
                  </div>
                  <div className="course-full-card__stat">
                    <span className="course-full-card__stat-icon">👥</span>
                    <span>{course.students} students</span>
                  </div>
                </div>
                <Link to={`/courses/${course.slug}`} className={`btn ${course.isFree ? 'btn--secondary' : 'btn--primary'}`}>
                  {course.isFree ? 'Start Free Course' : 'Enroll Now'}
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Coming soon */}
        <div className="courses-coming-soon">
          <div className="courses-coming-soon__inner">
            <span className="courses-coming-soon__emoji">🚀</span>
            <div>
              <h3 className="courses-coming-soon__title">More courses coming soon</h3>
              <p className="courses-coming-soon__desc">Subscribe to the newsletter to be the first to know when new courses launch.</p>
            </div>
            <Link to="/newsletter" className="btn btn--primary">Get Notified</Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Courses;
